module.exports = __webpack_public_path__ + "img/logo.0131e44a.png";